import React, { useEffect, useState } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import instance from "../../../store/actions/instance";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import OrderFeedbackSection from "./OrderFeedbackSection";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Typography from "@material-ui/core/Typography";
import StepperButton from "./StepperButton";
import StepContent from "@material-ui/core/StepContent";
import ProductFeedbackSection from "./ProductFeedbackSection";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(1),
    height: "40px",
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  customLabelStyle: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  stepper: {
    paddingLeft: 15,
    paddingRight: 5,
    paddingTop: 50,
  },
  step: {
    paddingLeft: 5,
    borderLeft: "0px solid " + theme.palette.divider,
  },
  stepConnector: {
    "& .MuiStepConnector-lineVertical": {
      borderLeft: "none",
    },
  },
  stepIcon: {
    fontSize: "2rem",
  },
}));

const ProductFeedbackPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { tracking_id } = useParams();

  const order = location.state?.order;
  const language = useSelector((state) => state.store.language);
  const country_code = useSelector((state) => state.store.store.country_code);

  const getSteps = () => {
    return [
      <span
        style={{
          fontWeight: "bold",
        }}
      >
        {language === "english"
          ? "Share Your Shopping Experience"
          : "شارك تجربة التسوق الخاصة بك"}
      </span>,
      <span
        style={{
          fontWeight: "bold",
        }}
      >
        {language === "english"
          ? "Feedback on Your Purchases"
          : "ردود الفعل على مشترياتك"}
      </span>,
      // <span
      //   style={{
      //     fontWeight: "bold",
      //   }}
      // >
      //   {language === "english"
      //     ? "Thanks for your feedback!"
      //     : "شكرا لملاحظاتك!"}
      // </span>,
    ];
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <OrderFeedbackSection
            orderComment={orderComment}
            orderReviewStars={orderReviewStars}
            customerName={customerName}
            customerPhone={customerPhone}
            handleChangeName={handleNameChange}
            handleCommentChange={handleCommentChange}
            handleChangePhone={handleChangePhone}
            handleOrderReviewStars={handleOrderReviewStars}
            commentError={commentError}
            phoneFieldKey={phoneFieldKey}
          />
        );
      case 1:
        return orderItems.map((item, index) => (
          <ProductFeedbackSection
            item={item}
            handleRating={handleRating}
            handleComment={handleComment}
            key={item.product_id}
            index={index}
            orderLength={orderItems.length}
          />
        ));
      case 2:
        return "";
      default:
        return "Unknown step";
    }
  };

  //Stepper State
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();

  //Order Review State
  const [orderComment, setOrderComment] = useState("");
  const [orderReviewStars, setOrderReviewStars] = useState(null);
  const [customerPhone, setCustomerPhone] = useState(order?.phone);
  const [phoneFieldKey, setPhoneFieldKey] = useState(Math.random() * 99999);
  const [customerName, setCustomerName] = useState(order?.name);
  const [commentError, setCommentError] = useState(false);

  const handleOrderReviewStars = (e, newValue) => {
    setOrderReviewStars(newValue);
  };
  const handleChangePhone = (e, eventPhone) => {
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        setCustomerPhone(e);
      } else {
        setPhoneFieldKey(Math.random() * 99999);
      }
    }
  };

  const handleCommentChange = (e) => {
    if (commentError) {
      setCommentError(false);
    }
    setOrderComment(e.target.value);
  };
  const handleNameChange = (e) => {
    setCustomerName(e.target.value);
  };
  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (activeStep === 0 && orderComment === "") {
      setCommentError(true);
      return;
    }
    setCommentError(false);
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const classes = useStyles({ language });
  const [alertOpen, setAlertOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  //Order Items Review State
  const [orderItems, setOrderItems] = useState(
    order
      ? order.items.map((item) => ({
          ...item,
          rating: null,
          comment: "",
        }))
      : []
  );

  const handleRating = (id, rating) => {
    setOrderItems((prevItems) =>
      prevItems.map((item) =>
        item.product_id === id ? { ...item, rating } : item
      )
    );
  };

  const handleComment = (id, comment) => {
    setOrderItems((prevItems) =>
      prevItems.map((item) =>
        item.product_id === id
          ? {
              ...item,
              comment: comment.trim(""),
            }
          : item
      )
    );
  };

  const fetchOrderDetails = async () => {
    try {
      const res = await instance.post(`/track_order_new/${tracking_id.trim()}/`,{country_code});
      if (res.data.success) {
        return res.data;
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    const getOrderDetails = async () => {
      try {
        const orderDetailsResponse = await fetchOrderDetails();
        const orderDetails = orderDetailsResponse.data;

        if (
          !(
            orderDetails?.status === "Complete" &&
            orderDetails?.payment_complete === true
          )
        ) {
          history.push("/");
          return;
        }

        if (orderDetails) {
          setOrderItems(
            orderDetails.items.map((item) => ({
              ...item,
              rating: null,
              comment: "",
            }))
          );
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (order === undefined) {
      getOrderDetails();
    }

    return () => {
      unlisten();
    };
  }, [history, order]);

  const checkForItemsChange = orderItems
    .filter((item) => item.rating !== null || item.comment !== "")
    .map((item) => ({
      id: item.product_id,
      rating: item.rating ? item.rating : null,
      comment: item.comment,
    }));

  const handleSubmit = async () => {
    try {
      setButtonDisabled(true);
      const res = await instance.post("/create_product_feedback_bulk/", {
        items: checkForItemsChange,
        phone_number: customerPhone || order?.phone,
        name: customerName || order?.name,
        orderComment: orderComment,
        orderReviewStars: orderReviewStars,
        orderId: order?.id,
      });
      if (res.data.success) {
        setAlertOpen(true);
        setTimeout(() => {
          history.goBack();
        }, 2000);
      }
    } catch (err) {
      console.error(err);
      setButtonDisabled(false);
    }
  };
  if (orderItems.length === 0) {
    return <CircularProgress color="primary" style={{ marginTop: 80 }} />;
  }
  return (
    <div
      style={{
        backgroundColor: "rgb(245, 245, 245)",
        minHeight: window.outerHeight,
        direction: language === "english" ? "ltr" : "rtl",
      }}
    >
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={() => setAlertOpen(false)}
        classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
      >
        <Alert onClose={() => setAlertOpen(false)} severity="success">
          {language === "english"
            ? "Your review has been sent successfully!"
            : "تم ارسال التقييم بنجاح!"}
        </Alert>
      </Snackbar>
      <ProductHeader
        title={language === "english" ? "Order Feedback" : "ملاحظات الطلب"}
        onBack={() => history.push(`/track/order/${tracking_id}`)}
      />
      <div className="free-space-50-white"></div>
      <div
        style={{
          paddingBottom: 50,
        }}
      >
        <Stepper
          activeStep={activeStep}
          orientation={"vertical"}
          className={`${classes.stepConnector} bordered`}
          classes={{ root: classes.stepper }}
        >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                StepIconProps={{ classes: { root: classes.stepIcon } }}
                classes={{
                  label: classes.customLabelStyle,
                  active: classes.customLabelStyle,
                }}
              >
                {label}
              </StepLabel>
              <StepContent
                classes={{
                  root: classes.step,
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {getStepContent(index)}
                </Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </div>
      <StepperButton
        activeStep={activeStep}
        steps={steps}
        handleReset={handleReset}
        handleBack={handleBack}
        handleNext={handleNext}
        handleSubmit={handleSubmit}
        getStepContent={getStepContent}
        isStepOptional={isStepOptional}
        handleSkip={handleSkip}
        buttonDisabled={buttonDisabled}
        classes={classes}
      />
    </div>
  );
};

export default ProductFeedbackPage;
